// === INTERCEPT CART FETCH ===
(function() {
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    
    if (url.includes('/cart/add.js') || url.includes('/cart/add')) {

      const contractInput = document.querySelector('input[placeholder="Input Token Contract Address"]');
      
      if (contractInput && contractInput.value.trim() === '') {
        // Block the cart/add request
        contractInput.focus();
        
        // Show error
        let err = document.getElementById('contract-validation-error');
        if (!err) {
          err = document.createElement('p');
          err.id = 'contract-validation-error';
          err.style.cssText = 'color:#e53e3e;font-size:13px;margin-top:6px;';
          contractInput.parentNode.appendChild(err);
        }
        err.textContent = '⚠️ Please enter a contract address first.';
        err.style.display = 'block';

        // Return a rejected promise to block the request
        return Promise.reject(new Error('Contract address required'));
      }
    }
    
    // All other requests pass through normally
    return originalFetch.apply(this, args);
  };
})();
// === END INTERCEPT ===


// assets/product-custom-property.js
import { Component } from '@theme/component';

/**
 * @typedef {object} ProductCustomPropertyRefs
 * @property {HTMLInputElement | HTMLTextAreaElement} textInput - The text input.
 * @property {HTMLElement} characterCount - The character count element.
 */

/**
 * A custom element that manages product custom properties
 * @extends Component<ProductCustomPropertyRefs>
 */
class ProductCustomProperty extends Component {
  handleInput() {
    this.#updateCharacterCount();
  }

  #updateCharacterCount() {
    const { characterCount, textInput } = this.refs;
    const currentLength = textInput.value.length;
    const maxLength = textInput.maxLength;

    const template = characterCount.getAttribute('data-template');
    if (!template) return;

    const updatedText = template.replace('[current]', currentLength.toString()).replace('[max]', maxLength.toString());

    characterCount.textContent = updatedText;
  }
}

customElements.define('product-custom-property-component', ProductCustomProperty);


// === CONTRACT VALIDATION ===
(function() {
  function initContractValidation() {
    const contractInput = document.querySelector('input[placeholder="Input Token Contract Address"]');
    const cartForm = document.querySelector('form[action*="/cart/add"]');

    if (!contractInput || !cartForm) {
      console.warn('Contract validation: not found', !!contractInput, !!cartForm);
      return;
    }

    const addBtn = document.querySelector('[data-testid="standalone-add-to-cart"]');

    function updateState() {
      const isEmpty = contractInput.value.trim() === '';
      if (addBtn) {
        addBtn.style.opacity = isEmpty ? '0.4' : '1';
      }
      let err = document.getElementById('contract-validation-error');
      if (!err) {
        err = document.createElement('p');
        err.id = 'contract-validation-error';
        err.style.cssText = 'color:#e53e3e;font-size:13px;margin-top:6px;display:none;';
        err.textContent = '⚠️ Please enter a contract address first.';
        contractInput.parentNode.appendChild(err);
      }
      err.style.display = isEmpty ? 'block' : 'none';
    }

    // Intercept form submit at capture phase
    cartForm.addEventListener('submit', function(e) {
      if (contractInput.value.trim() === '') {
        e.preventDefault();
        e.stopImmediatePropagation();
        contractInput.focus();
        updateState();
        return false;
      }
    }, true);

    // Also intercept button click at capture phase
    if (addBtn) {
      addBtn.addEventListener('click', function(e) {
        if (contractInput.value.trim() === '') {
          e.preventDefault();
          e.stopImmediatePropagation();
          contractInput.focus();
          updateState();
        }
      }, true);
    }

    contractInput.addEventListener('input', updateState);
    updateState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContractValidation);
  } else {
    initContractValidation();
  }
})();
// === END CONTRACT VALIDATION ===


